import { render, staticRenderFns } from "./HomeCategories.vue?vue&type=template&id=8e60e0b4&"
import script from "./HomeCategories.vue?vue&type=script&lang=js&"
export * from "./HomeCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports